import React from 'react';
import { Route, Routes } from 'react-router-dom';

import CommsCenterPage from '../analytics/CommsCenterPage';
import withPermissionRedirect from '../../wrappers/withPermissionRedirect';
import { INVOICE_DETAILS } from '../../firewall/permissions';
import PageNavigate from '../PageNavigate';
import Error404 from '../error-pages/Error404';

const CommsCenterPageWithInvoiceDetailsAccess = withPermissionRedirect(INVOICE_DETAILS)(CommsCenterPage);

const CommsCenterRoutes = () => (
  <Routes>
    <Route
      path="delivery-performance"
      element={<CommsCenterPage dashboardId="delivery_performance" type="dashboard" />}
    />
    <Route
      path="partner-interface-usage"
      element={<CommsCenterPage dashboardId="partner_interface" type="dashboard" />}
    />
    <Route
      path="invoice-details"
      element={<CommsCenterPageWithInvoiceDetailsAccess dashboardId="invoice_data" type="look" />}
    />
    <Route index element={<PageNavigate to="delivery-performance" />} />
    <Route path="*" element={<Error404 />} />
  </Routes>
);

export default CommsCenterRoutes;
